<template>
  <div class="login-bg">
    <div class="container">
      <div class="row justify-content-center mb-4">
        <div class="col-lg-12 text-center">
          <h2
            v-bind:style="{
              color: '#fff',
              fontWeight: 'bold',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.9)',
            }"
          >
            {{ tagline }}
          </h2>
        </div>
        <div class="row justify-content-center">
          <div class="card rounded-lg">
            <!-- <b-row class="justify-content-center mt-2">
              <div class="logo text-center">
                <img src="/img/navbar/logo.png" alt="Logo" />
              </div>
            </b-row> -->
            <div class="card-body pl-5 pr-5">
              <h3 class="text-left">{{ $t("forgotyourPassword") }}</h3>
              <p>{{ $t("enterEmailPhone") }}</p>
              <form class="theme-form" @submit.prevent="onSubmit">
                <!-- Replace the v-text-field block with a labeled version -->
                <div class="form-group">
                  <label class="input-label" for="resetInput">{{
                    $t("contactUs.email")
                  }}</label>
                  <v-text-field
                    id="resetInput"
                    v-model="text"
                    :placeholder="$t('contactUs.emailPlaceholder')"
                    outlined
                    dense
                  ></v-text-field>
                </div>

                <div class="pt-4 form-group text-center">
                  <template v-if="!isLoading">
                    <div
                      class="d-flex justify-content-center align-items-center flex-wrap gap-2"
                    >
                      <b-button class="btn-primary" size="sm" type="submit">
                        {{ $t("cart.continue") }}
                      </b-button>
                      <router-link class="modal-title-otp" to="/login">
                        {{ $t("returnLogin") }}
                      </router-link>
                    </div>
                  </template>

                  <template v-if="isLoading">
                    <b-spinner
                      v-for="i in 3"
                      :key="i"
                      class="mr-1"
                      small
                      label="Small Spinner"
                      type="grow"
                    ></b-spinner>
                  </template>
                </div>
              </form>
              <!-- <p class="pt-2" style="font-size: 13px">
                By continuing, you agree to Indian Mangoes
                <router-link
                  to="/terms_conditions"
                  style="text-decoration: underline"
                  >Terms & Conditions</router-link
                >
                of Use and
                <router-link
                  to="/privacy-policy"
                  style="text-decoration: underline"
                >
                  Privacy Policy</router-link
                >
              </p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "/public/config.json";
export default {
  name: "forgotPassword",
  computed: {
    isPhoneValid() {
      if (this.phone == "") return true;
      var isPhone = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
      if (isPhone.test(this.phone)) {
        return true;
      } else {
        return false;
      }
    },
  },
  data() {
    return {
      phone: "",
      isLoading: false,
      appName: config.appName,
      tagline: config.tagline,
    };
  },

  methods: {
    async onSubmit() {
      if (!this.text) {
        this.$swal({
          type: "error",
          title: "Missing Fields",
          text: "All fields are required. Please fill in all the details.",
        });
        return;
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^[6-9]\d{9}$/;
      const payload = {};
      let successMessage = "";
      if (emailRegex.test(this.text)) {
        payload.email = this.text;
        successMessage =
          "We have sent you an Verification Code on your registered email.";
      } else if (phoneRegex.test(this.text)) {
        payload.phone = this.text;
        successMessage =
          "We have sent you an Verification Code on your registered number.";
      }

      try {
        this.isLoading = true;
        const result = await this.$store.dispatch(
          "auth/forgotPasswordAction",
          payload,
        );
        this.$swal({
          title: "Thank You!!",
          text: successMessage,
          type: "success",
          timer: 1200,
        }).then(() => {
          this.$router.push({
            name: "newPassword",
            params: {
              resetRefId: result.data.response.resetRef,
              text: this.text,
            },
          });
        });
      } catch (err) {
        this.$swal({
          title: "Error",
          text: err.response?.data?.message || "Something went wrong",
          type: "error",
          timer: 1200,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
<style scoped>
a {
  color: var(--primarycolor) !important;
  cursor: pointer;
}

form input {
  display: inline-block;
  width: 50px;
  height: 50px;
  text-align: center;
}
@media (max-width: 768px) {
  h2 {
    font-size: 20px !important;
    padding: 0 10px;
  }
  .primary-btn {
    width: 100%;
    font-size: 16px;
    white-space: normal;
  }
  .card {
    margin: 20px auto;
    padding: 20px 15px;
  }

  .form-group {
    margin-bottom: 1rem;
  }

  .v-input input {
    font-size: 16px;
  }

  .checkbox p {
    font-size: 13px;
  }

  .primary-btn {
    font-size: 16px;
    padding: 0.75rem;
  }

  .logo img {
    width: 60px;
  }
}
.card {
  max-width: 500px;
  width: 100%;
  margin-left: auto;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
.login-bg {
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 2rem 1rem;
}
.login-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: url("/img/login/login_bg_img.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scaleX(-1);
  z-index: -1;
  opacity: 0.4;
}
.modal-title-otp a:hover {
  text-decoration: underline !important;
}
.btn-primary {
  padding: 0.5rem 8rem;
}
.is-valid-phone {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 9px;
  color: red;
}
.border {
  border: 1px solid #000;
}
.modal-title-otp {
  color: #579a70;
  cursor: pointer;
}
.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 34px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #fff;
  width: 65%;
}
</style>
